<style lang="scss" scoped>
@import "details";
.search-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	.el-form-item {
		margin-bottom: 0;
	}
}
.record-details {
	display: flex;
	align-items: center;
	.title {
		width: 150px;
		min-height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	dl {
		flex: 1;
		border-left: 1px solid #e4e6ea;
		dd {
			padding: 12px 0;
			border-bottom: 1px solid #e4e6ea;
			&:last-child {
				border: 0;
			}
		}
	}
}
</style>
<style lang="scss">
.user-details .el-table__expanded-cell[class*="cell"] {
	padding: 0 !important;
}
.cons{
  display: none;
}
@media screen and (max-width: 640px){
  .container{
    width: 90% !important;
    font-size: 12px!important;
  }
  .con{
    display: none!important;
  }
  .cons{
    display: block!important;
  }
  .text-lists {
    display: block!important;
  }
  .text-lists li {
    width: 100% !important;
  }
  .container h3.title {
    font-size: 20px !important;
  }
}
</style>
<template>
	<div class="user-details">
		<section class="container">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/user' }"
					>用户中心</el-breadcrumb-item
				>
				<el-breadcrumb-item
					><router-link to="/user/fastNGS"
						>fast NGS订单</router-link
					></el-breadcrumb-item
				>
				<el-breadcrumb-item>Fast NGS订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<h3 class="title">Fast NGS订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
			<ul class="text-lists">
				<li v-show="isHeadMan">
					<span>关联用户：</span>{{ details.customerName }}
				</li>
				<li><span>订单创建者：</span>{{ details.createUserName }}</li>				
				<li><span>实验基地：</span>{{ details.baseName }}</li>
				<li>
					<span>订单创建时间：</span
					>{{ details.value&&details.value.createTime | rTime }}
				</li>
				<li><span>收货地址：</span>{{ address }}</li>
			</ul>
      
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
			
      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20" border :data="orderTable">
				<el-table-column prop="no" width="200" label="订单编号"> </el-table-column>
				 <el-table-column label="下单时间" width="160">
					<template slot-scope="scope">{{
						scope.row.createTime | rTime
					}}</template>
				</el-table-column>
				<el-table-column prop="totalNum" label="反应总数">
				</el-table-column>
				<el-table-column prop="realSuccessNum" label="成功反应数">
				</el-table-column>
				<el-table-column prop="realFailNum" label="失败反应数">
				</el-table-column>
        <el-table-column prop="successPayNum" label="成功计费反应数">
				</el-table-column>
        <el-table-column prop="failPayNum" label="失败计费反应数">
				</el-table-column>
				<el-table-column label="订单金额（元）" width="120">
					<template slot-scope="scope">{{
						scope.row.settlementAmount | amount
					}}</template>
				</el-table-column>
        <el-table-column prop="orderStatusName" label="订单状态">
				</el-table-column>
        <el-table-column prop="settlementStatusName" label="结算状态" >
				</el-table-column>
				
			</el-table>
			<h3 class="title">订单包含反应信息</h3>
			<div class="search-top con">
				<el-form
					:inline="true"
					:model="searchForm"
					class="demo-form-inline"
				>
					<el-form-item label="样品名称：">
						<el-input
							v-model="searchForm.demoName"
							placeholder="请输入样品名称"
						></el-input>
					</el-form-item>					
					<el-form-item>
						<el-button type="primary" @click="bindSearch"
							>搜索</el-button
						>
					</el-form-item>
				</el-form>
				<div class="download">
					<a class="pointer mr20" @click="getWorkerDoc"
						><span class="el-icon-download"></span>结果下载</a
					>
					<a class="pointer" @click="getDetailsExcel"
						><span class="el-icon-download"></span>明细表下载</a
					>
				</div>
			</div>
      <div class="cons">
        <div class="search-top">
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
          >
            <el-form-item label="样品名称：" style="margin-bottom: 10px;">
              <el-input
                v-model="searchForm.demoName"
                placeholder="请输入样品名称"
              ></el-input>
            </el-form-item>            
            <el-form-item>
              <el-button type="primary" size="small" @click="bindSearch"
              >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="download" style="margin-top: 10px;">
          <a class="pointer mr20" @click="getWorkerDoc"
          ><span class="el-icon-download"></span>结果下载</a
          >
          <a class="pointer" @click="getDetailsExcel"
          ><span class="el-icon-download"></span>明细表下载</a
          >
        </div>
      </div>
			<el-table
				border
				class="mt20"
        :header-cell-style="{
          background:'#f7f9fa',
          color: '#4e5051',
          textAlign: 'center'
        }"
        :cell-style="{
          textAlign: 'center'
        }"
				:data="reactionLists"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column
					prop="value.no"
					width="240"
					label="反应工单号"
				>
				</el-table-column>
				<el-table-column prop="value.name" label="样品名称">
				</el-table-column>
				<el-table-column prop="value.demoType" label="样品类型">
				</el-table-column>
        <el-table-column prop="value.expectedLength" label="预期片段长度">
				</el-table-column>
        <el-table-column prop="value.depth" label="测序深度">
				</el-table-column>  
				<el-table-column
					prop="value.appraisalStatusType"
					label="鉴定状态"
				>
        <template slot-scope="scope">{{scope.row.value.appraisalStatusType | appraisalStatusTotext}}</template>				
        </el-table-column>
        <el-table-column prop="value.price" label="价格">
            <template slot-scope="scope" v-if="scope.row.value.order.status == 'END'">{{handlePrice(scope.row.value)}}</template>
				</el-table-column>
        <el-table-column prop="value.reactionStatus" label="反应状态">
          <template slot-scope="scope">{{scope.row.value.reactionStatus | reactionStatusTotext}}</template>
				</el-table-column>
				
			</el-table>
			<div class="page tr">
				<el-pagination
					:page-size="10"
					:pager-count="7"
					layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
					:total="reactionTotal"
          @size-change="changeSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
			
		</section>

		
	</div>
</template>

<script>
import { showLoading, hideLoading } from './children/loading'
import {hightOrderReaction,highThroughputOrders,highOrdersWorderDocK,highOrdersExcel}from '@/services/api.index'
import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'

export default {
  filters:{
    reactionStatusTotext(v){ 
      let objArr=[
        {key:"ING",text:"实验中"},
        {key:"PAUSE",text:"暂停"},
        {key:"CLOSE",text:"关闭"},
        {key:"S",text:"成功"},
        {key:"F",text:"失败"},
        ]
      let obj=objArr.find(item=>item.key==v);
      return obj&&obj.text||'-';
    },
    appraisalStatusTotext(v){     
      let objArr=[
        {key:"NORMAL",text:"正常"},
        {key:"PAUSE",text:"暂停"},
        {key:"CANCEL",text:"取消测序"},
        {key:"RESHAKE",text:"重摇"},
        ]      
      let obj=objArr.find(item=>item.key==v);
      return obj&&obj.text||'-';
    },
  },
  data() {
    return {
      tableHeaderStyle,
      tableCellStyle,
      visible: false,
      form: {
        returnDemoStatus: '',
        returnDemoRemark: ''
      },
      rules: {
        returnDemoStatus: [{ required: true, message: '请选择' }]
      },
      row: {}, // 要返样的行数据
      returnDemoStatusMap: [
        {
          label: 'PCR',
          value: '是-PCR'
        },
        {
          label: '菌液',
          value: '是-A'
        },
        {
          label: '质粒',
          value: '是-B'
        },
        {
          label: '平板',
          value: '是-C'
        },
        {
          label: '菌液/质粒',
          value: '是-A/B'
        },
        {
          label: '质粒/平板',
          value: '是-B/C'
        },
        {
          label: '菌液/平板',
          value: '是-A/C'
        },
        {
          label: '菌液/质粒/平板',
          value: '是-A/B/C'
        }
      ],

      searchForm: {        
        demoName: ''
      },
      id: this.$route.query.id,
      details: {},
      address: '',
      orderTable: [],
      reactionLists: [],
      reactionTotal: 0,
      reactionPage: 0,
      reactionSize: 10,
      sendLists: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
      showDistribution: true,
      multipleSelection: [],
      isHeadMan: this.baseMethods.isHeadMan()
    }
  },
  created() {
    this.getDetails()
    this.getReaction()
  },
  methods: {
    handlePrice(val) {
      if(val.reactionStatus === 'S') {
        return val.unitPrice
      }else if(val.reactionStatus === 'F') {
        return val.failPrice
      }else return 0
    },
    formatChargeType({ chargeType, status, reactionStatusName }) {
      if(['ING', 'PAUSE', 'CLOSE'].includes(status)){
        return ''
      }
      const { freeFlag } = this.details.value||{};
      if(freeFlag || status === 'F'){
        return `${reactionStatusName},不收费`
      }
      return `${reactionStatusName},${chargeType === 'S' ? '收费' : '不收费'}`
    },
    getReturnDemoStatus(returnDemoStatus) {
      let status = this.returnDemoStatusMap.find(v => v.value === returnDemoStatus)
      return status ? status.label : '否'
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 订单详情
    getDetails() {     
      highThroughputOrders(this.id).then((res) => {        
        this.details = res.data       
        let value ={...res.data.value,...res.data}
        value.orderStatusName = this.baseMethods.orderStatus(
          res.data.userWebOrderStatus
        )
        value.settlementStatusName = this.baseMethods.settlementStatus(
          value.settlementStatus
        )
        this.address = value.raProvince
          ? `${value.raProvince}${value.raCity}${value.raCounty} ${value.raAddress}`
          : ''  
        this.orderTable=[value];
      })
    },
    
    bindSearch() {
      this.reactionPage = 0
      this.getReaction()
    },
    // 订单包含反应信息
    getReaction() {
      const { reactionPage, reactionSize } = this
      const { demoName } = this.searchForm
      hightOrderReaction(
        this.id,
        reactionPage,
        reactionSize,
        demoName,
      ).then((res) => {        
        res.data.list.map((item) => { 
          item.value.demoType = this.baseMethods.demoType(
            item.value.plate.type
          )
        })
        
        this.reactionLists = res.data.list
        this.reactionTotal = res.data.totalCount
      })
    },  
    // 反应信息多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 明细表下载
    getDetailsExcel() {
       let multipleSelection=this.multipleSelection;
       if(multipleSelection.length===0){
        return this.$message.warning("请选择需要下载的订单");
       }
       if(multipleSelection){
          let ids=multipleSelection.map(item=>item.value.id);
          showLoading();
          setTimeout(() => {
            highOrdersExcel({"demoIds":ids}).then((res) => {
                this.baseMethods.downloadFile(res.data, "Fast NGS明细表");
            }).finally(()=>{
                    hideLoading(); 
            });
          }, 2000);
       }    
      
    },
    // 工单下载
    getWorkerDoc() {
      let multipleSelection=this.multipleSelection;
       if(multipleSelection.length===0){
        return this.$message.warning("请选择需要下载的订单");
       }
       if(multipleSelection){
          let ids=multipleSelection.map(item=>item.value.id);
          showLoading();          
          highOrdersWorderDocK({"demoIds":ids}).then((res) => { 
            let date= this.baseMethods.formatDate(new Date()).join('-');                            
                this.baseMethods.downloadFile(
                  res.data,
                  `结果文件${date}`,
                  "doc"
                );
            }).finally(()=>{
              hideLoading(); 
            });
       }
     
    },
    // 翻页
    changePage(value) {
      this.reactionPage = value - 1
      this.getReaction()
    },
    changeSize (value) {
      this.reactionSize = value
      this.getReaction()
    },
    changeSendPage(value) {
      this.sendPage = value - 1      
    },
		
  }
}
</script>
<style>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .el-dialog{
    width: 90%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/fastNGS_details.vue